import { TSelectboxOption } from "../../components/admin/formFields";

export enum REPORT_ENTITIES {
  VEHICLE = 'asset',
  DRIVER = 'driver',
}

// TODO: deprecated, to be removed
export type TReportTypes = 'asset_report' | 'driver_details_report' | 'group_summary_report' | 'asset_performance_report' | 'driver_performance_report' | 'ifta_detail_report';

// TODO: deprecated, to be removed
export type TSubReportTypesVehicle = 'assets_near_asset' | 'battery_health' | 'coolant_temprature' | 'daily_distance_driven' | 'digital_input_report' | 'event_detail' | 'event_detail_all' | 'event_detail_speeding' | 'geozone_report' | 'harsh_acceleration_report' | 'harsh_braking_report' | 'idle_report';
export type TSubReportTypesDriverDetail = 'alert_by_status' | 'asset_alert_detail';
export type TSubReportTypesGroupSummary = 'assets_near_categorized_geozone_groups' | 'assets_near_geozone';
export type TSubReportTypesVehiclePerformance = 'exceeding_posted_speed' | 'speeds_over';
export type TSubReportTypesDriverPerformance = 'driver_events' | 'driver_behaviour_report';
export type TSubReportTypesIftaDetail = 'state_border_crossing_summary' | 'state_mileage_summary' | 'intra_state_mileage_summary';

// TODO: deprecated, to be removed
export type TReportTypesWithUuidSubReportSlug =
  TSubReportTypesVehicle
  | TSubReportTypesDriverDetail
  | TSubReportTypesGroupSummary
  | TSubReportTypesVehiclePerformance
  | TSubReportTypesDriverPerformance
  | TSubReportTypesIftaDetail;

// TODO: deprecated, to be removed
export type TReportTypesWithUuid = {
  [key: string]: {
    slug: TReportTypes;
    label?: string;
    subReports: {
      uuid?: string;
      label?: string;
      slug: TReportTypesWithUuidSubReportSlug;
      additionalFields?: {
        slug: string;
        type: string;
        options?: TSelectboxOption[];
        option_source?: string;
        option_source_value?: string;
        option_source_label?: string;
      }[];
    }[];
  };
};

export type TStandardReportFieldsType = {
  
}

export type TMapRef = {
  map: any;
  objects: any;
}